import dingSound from '../assets/sounds/ding.mp3';
import melodySound from '../assets/sounds/chime.mp3';
import alertSound from '../assets/sounds/alert.mp3';

const SOUND_MAP: Record<string, string> = {
  ding: dingSound,
  melody: melodySound,
  alert: alertSound,
};

const SYNTH_GAIN = 1.0;
const FILE_GAIN = 3.0;

function playSynthChime() {
  try {
    const ctx = new AudioContext();
    const now = ctx.currentTime;
    [523.25, 659.25].forEach((freq, i) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.type = 'sine';
      osc.frequency.value = freq;
      gain.gain.setValueAtTime(SYNTH_GAIN, now + i * 0.15);
      gain.gain.exponentialRampToValueAtTime(0.001, now + i * 0.15 + 0.3);
      osc.connect(gain);
      gain.connect(ctx.destination);
      osc.start(now + i * 0.15);
      osc.stop(now + i * 0.15 + 0.3);
    });
    setTimeout(() => ctx.close(), 1000);
  } catch {
    // AudioContext not available
  }
}

export function playOnlineOrderSound(soundType: string) {
  const src = SOUND_MAP[soundType];
  if (!src) {
    playSynthChime();
    return;
  }
  try {
    const audio = new Audio(src);
    audio.volume = 1.0;
    try {
      const ctx = new AudioContext();
      const source = ctx.createMediaElementSource(audio);
      const gain = ctx.createGain();
      gain.gain.value = FILE_GAIN;
      source.connect(gain);
      gain.connect(ctx.destination);
      audio.addEventListener('ended', () => ctx.close());
    } catch {
      // fall through to plain element playback
    }
    audio.play().catch(() => {});
  } catch {
    playSynthChime();
  }
}
